// import React, { useEffect, useState } from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Box, Typography, Button, Stepper, Step, StepLabel, StepContent, Chip,
// } from '@mui/material';
// import { fetchWorkflowHistory, STAGE_LABELS } from './workflowApi';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';

// const ACTION_LABELS = {
//   submit_workflow_1: 'Submitted (Workflow 1 — Full Agreement)',
//   submit_workflow_2: 'Submitted (Workflow 2 — Forensic Auditor Route)',
//   forward: 'Forwarded',
//   return: 'Returned',
//   reassign_case_worker: 'Case Worker Reassigned',
//   approve_finalize: 'Approved & Finalized',
//   close: 'Closed',
// };

// const WorkflowHistoryDialog = ({ open, onClose, excessId, refId }) => {
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]);
//   const [currentStage, setCurrentStage] = useState(null);

//   useEffect(() => {
//     if (!open || !excessId) return;
//     setLoading(true);
//     fetchWorkflowHistory(excessId)
//       .then((res) => {
//         setHistory(res.data?.history || []);
//         setCurrentStage(res.data?.current_stage);
//       })
//       .catch(() => {
//         setHistory([]);
//       })
//       .finally(() => setLoading(false));
//   }, [open, excessId]);

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Case History — {refId}
//         {currentStage && (
//           <Chip
//             label={STAGE_LABELS[currentStage] || currentStage}
//             size="small"
//             color="primary"
//             sx={{ ml: 1.5, fontWeight: 600 }}
//           />
//         )}
//       </DialogTitle>
//       <DialogContent dividers>
//         {loading ? (
//           <Box display="flex" justifyContent="center" py={3}>
//             <LoadingSpinner size={24} />
//           </Box>
//         ) : history.length === 0 ? (
//           <Typography variant="body2" color="text.secondary" textAlign="center" py={2}>
//             No actions recorded yet.
//           </Typography>
//         ) : (
//           <Stepper orientation="vertical" nonLinear activeStep={history.length}>
//             {history.map((h, idx) => (
//               <Step key={idx} completed>
//                 <StepLabel>
//                   <Typography fontWeight={600}>
//                     {ACTION_LABELS[h.action] || h.action}
//                   </Typography>
//                 </StepLabel>
//                 <StepContent>
//                   <Typography variant="body2" color="text.secondary">
//                     {h.from_stage ? `${STAGE_LABELS[h.from_stage] || h.from_stage} → ` : ''}
//                     {STAGE_LABELS[h.to_stage] || h.to_stage}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary" display="block">
//                     By {h.performed_by} ({h.performed_role}) — {new Date(h.created).toLocaleString()}
//                   </Typography>
//                   {h.remarks && (
//                     <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
//                       "{h.remarks}"
//                     </Typography>
//                   )}
//                 </StepContent>
//               </Step>
//             ))}
//           </Stepper>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Close</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default WorkflowHistoryDialog;


import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, Chip, Table, TableHead, TableRow,
  TableCell, TableBody, Avatar, Grid, Divider,
} from '@mui/material';
import { fetchWorkflowHistory, STAGE_LABELS } from './workflowApi';
import { LoadingSpinner } from '../../../Components/spinner/spinner';

const fmtMoney = (n) => `₹ ${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const ACTION_LABELS = {
  submit_workflow_1: 'Submitted (Workflow 1)',
  submit_workflow_2: 'Submitted (Workflow 2)',
  forward: 'Forwarded',
  return: 'Returned',
  reassign_case_worker: 'Case Worker Reassigned',
  approve_finalize: 'Approved & Finalized',
  close: 'Closed',
};

const ACTION_COLORS = {
  submit_workflow_1: 'success',
  submit_workflow_2: 'secondary',
  forward: 'primary',
  return: 'warning',
  reassign_case_worker: 'info',
  approve_finalize: 'success',
  close: 'default',
};

const SummaryStat = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
    <Typography variant="body2" fontWeight={700}>{value}</Typography>
  </Box>
);

const WorkflowHistoryDialog = ({ open, onClose, excessId, refId }) => {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [currentStage, setCurrentStage] = useState(null);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!open || !excessId) return;
    setLoading(true);
    fetchWorkflowHistory(excessId)
      .then((res) => {
        setHistory(res.data?.history || []);
        setCurrentStage(res.data?.current_stage);
        setSummary(res.data?.record_summary || null);
      })
      .catch(() => { setHistory([]); setSummary(null); })
      .finally(() => setLoading(false));
  }, [open, excessId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Case History — {refId}
        {currentStage && (
          <Chip
            label={STAGE_LABELS[currentStage] || currentStage}
            size="small"
            color="primary"
            sx={{ ml: 1.5, fontWeight: 600 }}
          />
        )}
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" py={3}>
            <LoadingSpinner size={24} />
          </Box>
        ) : (
          <>
            {/* AMOUNT / INSTALLMENT SUMMARY */}
            {summary && (
              <Box sx={{ mb: 2.5, p: 1.5, bgcolor: 'grey.50', borderRadius: 1.5 }}>
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={3}>
                    <SummaryStat label="Excess Amount" value={fmtMoney(summary.excess_amount)} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <SummaryStat
                      label="Agreed to Pay"
                      value={summary.is_agreed_to_pay ? 'Yes' : summary.is_not_agreed_to_pay ? 'No' : 'Pending'}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <SummaryStat label="Agreed Amount" value={summary.agreed_amount ? fmtMoney(summary.agreed_amount) : '—'} />
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <SummaryStat label="No. of Installments" value={summary.no_of_installment || summary.installment_count || '—'} />
                  </Grid>
                  {(summary.agreed_amount_as_per_forensic_auditor || summary.forensic_auditor_status) && (
                    <>
                      <Grid item xs={6} sm={3}>
                        <SummaryStat
                          label="Forensic Audited Amount"
                          value={summary.agreed_amount_as_per_forensic_auditor ? fmtMoney(summary.agreed_amount_as_per_forensic_auditor) : '—'}
                        />
                      </Grid>
                      {/* <Grid item xs={6} sm={3}>
                        <SummaryStat label="Forensic Status" value={summary.forensic_auditor_status || '—'} />
                      </Grid> */}
                    </>
                  )}
                </Grid>
              </Box>
            )}
            <Divider sx={{ mb: 2 }} />

            {history.length === 0 ? (
              <Typography variant="body2" color="text.secondary" textAlign="center" py={2}>
                No actions recorded yet.
              </Typography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>When</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Action</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Stage Change</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>By (Role)</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {history.map((h, idx) => (
                    <TableRow key={idx} hover>
                      <TableCell sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                        <Typography variant="body2">{new Date(h.created).toLocaleDateString()}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(h.created).toLocaleTimeString()}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Chip
                          size="small"
                          label={ACTION_LABELS[h.action] || h.action}
                          color={ACTION_COLORS[h.action] || 'default'}
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>

                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Typography variant="body2" color="text.secondary">
                          {h.from_stage ? `${STAGE_LABELS[h.from_stage] || h.from_stage} → ` : '— → '}
                          {STAGE_LABELS[h.to_stage] || h.to_stage}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ verticalAlign: 'top' }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Avatar sx={{ width: 26, height: 26, fontSize: 12 }}>
                            {(h.performed_by_name || '?')[0]?.toUpperCase()}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight={600}>{h.performed_by_name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {h.performed_role}{h.performed_by_email ? ` · ${h.performed_by_email}` : ''}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell sx={{ verticalAlign: 'top', maxWidth: 240 }}>
                        <Typography variant="body2" sx={{ fontStyle: h.remarks ? 'italic' : 'normal' }} color={h.remarks ? 'text.primary' : 'text.disabled'}>
                          {h.remarks || 'No remarks'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkflowHistoryDialog;